// 收入类型状态值
export const INCOME_TYPE_STATUS_MAP = {
  0: 'processing',
  1: 'default',
};

export const INCOME_FORM_STATUS_MAP = {
  1: 'default', // 未提交
  2: 'processing', // 审批中
  3: 'error', // 已驳回
  4: 'success', // 已完成
  5: 'default', // 已作废
  6: 'default',
  7: 'default',
};

// formStatus 1-未提交、2-审批中、3-已驳回、4-已完成、5-已作废、6-待审批、7-待审核
export const INCOME_FORM_AUDIT_STATUS_MAP = {
  0: 'default', // 待审批
  1: 'default', // 待审核
  2: 'success', // 通过
  3: 'error', // 驳回
};

export const TABS_LIST = [
  {
    label: '待处理',
    value: 1,
  },{
    label: '已处理',
    value: 2,
  }
];
// 审批列表筛选
export const TABLE_STATUS = {
  all: 0,
  pending: 1,
  complete: 2,
};
// 收入类型状态
export const CATEGORY_STATUS = {
  stop: 1, 
  available: 0,
};
// 需要必填地址， 开户银行的， 电话账号的发票类型
export const SPECIAL_INVOICE_TYPE = [10001, '10001'];


// export const CONFIG_KEYS = ['APPLY_FORM_STATUS_ENUM','PAY_STATUS_ENUM','INVOICE_TYPE_ENUM'];
export enum CONFIG_KEYS {
  // eslint-disable-next-line no-unused-vars
  APPLY_FORM_STATUS_ENUM = 'APPLY_FORM_STATUS_ENUM',
  // eslint-disable-next-line no-unused-vars
  PAY_STATUS_ENUM = 'PAY_STATUS_ENUM',
  // eslint-disable-next-line no-unused-vars
  INVOICE_TYPE_ENUM = 'INVOICE_TYPE_ENUM',
  // eslint-disable-next-line no-unused-vars
  APPLY_FORM_STATUS_ENUM_UNFINISHED = 'APPLY_FORM_STATUS_ENUM_UNFINISHED',
  // eslint-disable-next-line no-unused-vars
  APPLY_FORM_STATUS_ENUM_FINISHED = 'APPLY_FORM_STATUS_ENUM_FINISHED'
}

// 支付状态
export const PAY_STATUS = {
  unPay: 0,
  paid: 1,
};

export const getIncomeEnumConfig = (data:Array<any>, type: CONFIG_KEYS) => {
  const current = (data || []).find(item => item.groupCode === type);
  const { configROS = [] } = current || {};
  return configROS;
};

// 单据列表类型
export const INCOME_LIST_TYPE =  {
  applyPending: 1, // 申请列表未完成
  audit: 2, // 审批列表
  manage: 3, // 单据管理列表
  applyComplete: 4, // 申请已完成
};

// 角色
export const USER_ROLE = {
  self: 0, // 本人
  approval: 1, // 审批
  audit: 2, // 审核
};
// formStatus 1-未提交、2-审批中、3-已驳回、4-已完成、5-已作废、6-待审批、7-待审核
export const FORM_STATUS_IMG_LIST = {
  1: 'https://sitecdn.zcycdn.com/f2e-assets/28acfa17-b294-499f-a35e-0e883230065b.svg',
  2: 'https://sitecdn.zcycdn.com/f2e-assets/5bf88e1d-0dff-4533-a4fd-35569f16a6be.svg',
  3: 'https://sitecdn.zcycdn.com/f2e-assets/4a9f24bd-d03b-4510-8b86-275d9a18fcf1.svg',
  4: 'https://sitecdn.zcycdn.com/f2e-assets/a5248bb3-87ae-407b-a3f4-8077dce72c70.svg',
  5: 'https://sitecdn.zcycdn.com/f2e-assets/f644ba41-d18d-4b36-99db-942de62c8fb9.svg',
  6: 'https://sitecdn.zcycdn.com/f2e-assets/ffe4300c-8a7b-4d9a-a1af-ccdca8f00ae2.svg', // 待审批
  7: 'https://sitecdn.zcycdn.com/f2e-assets/17e09503-2fc0-4616-ad0b-c3aa1c0d9297.svg', // 待审核
};